/**
 * core/embed/frontend.js
 *
 * @author gbuttinger
 */

/*
We have to add this event listener outside of the document ready function,
to make sure it is added before the allowed events ar fired by gdpr-consent-manager on page load.
*/
document
  .getElementById("gdpr-consent-manager")
  .addEventListener("allowed", function (event) {
    document
      .querySelectorAll(
        `.gdpr-consent-block[data-gdpr-service="${event.detail}"]`
      )
      .forEach(function (consentBlock) {
        // Hide the consent information block
        consentBlock.style.display = "none";

        // Show the third party content
        const thirdPartyContent =
          consentBlock.previousElementSibling.querySelector("[data-gdpr-src]");
        thirdPartyContent.setAttribute(
          "src",
          thirdPartyContent.getAttribute("data-gdpr-src")
        );
        thirdPartyContent.setAttribute("data-grpr-is-consented", "");
        thirdPartyContent.closest(".wp-block-embed").style.display = null;
      });
  });

// Stuff to do on document ready
document.addEventListener("DOMContentLoaded", function () {
  // Hide complete embed block for all non-consented embeds
  document
    .querySelectorAll(`[data-gdpr-src]:not([data-grpr-is-consented])`)
    .forEach(function (thirdPartyContent) {
      thirdPartyContent.closest(".wp-block-embed").style.display = "none";
    });
  // Add event listeners to all consent buttons
  document
    .querySelectorAll(`.gdpr-consent-block`)
    .forEach(function (consentBlock) {
      const service = consentBlock.getAttribute("data-gdpr-service");
      const consentButton = consentBlock.querySelector("button");
      consentButton.addEventListener("click", function () {
        allow(service);
      });
    });
});
